







































































import { Video as IVideo } from "@/api/models/video";
import { Vue, Component, Prop } from "vue-property-decorator";
import { User as IUser } from "@/api/models/user";
import { isRoot, getCurrentUserId } from "@/plugins/roles";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
@Component
export default class recordListItem extends Vue {
  @Prop() video!: IVideo;
  recordTeacher!: IUser;
  showDetail: boolean = false;
  data() {
    return {
      recordTeacher: undefined
    };
  }

  getTeacher() {
    api.UsersApi.get(this.video.ownerId)
      .then((res: { data: IUser }) => {
        this.recordTeacher = res.data;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  get userId() {
    return getCurrentUserId();
  }

  get root() {
    return isRoot();
  }

  get videoOwner() {
    return this.userId === this.video.ownerId;
  }

  get videoCompanyOwner() {
    return this.$store.getters.userIsCompanyOwner
      ? this.$store.getters.userIsCompanyOwner
      : false;
  }

  get canEdit() {
    return this.root || this.videoOwner || this.videoCompanyOwner;
  }

  mounted() {
    this.getTeacher();
  }
}
